import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CreditCardService, CreditCardType } from '../credit-card';

export class CreditCardValidators {
  static numberFormat(creditCardService: CreditCardService): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string | null = control.value;

      if (value === null) {
        return null;
      } else if (creditCardService.validateNumber(value)) {
        return null;
      } else {
        return { numberFormat: true };
      }
    };
  }

  static cardType(creditCardService: CreditCardService, ...allowedCardTypes: (CreditCardType | null)[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string | null = control.value;

      if (value === null || creditCardService.validateNumber(value) === false) {
        return null;
      } else if (allowedCardTypes.includes(creditCardService.getCardType(value, { removeWhitespace: true }))) {
        return null;
      } else {
        return { cardType: true };
      }
    };
  }

  static expiryFormat(creditCardService: CreditCardService): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string | null = control.value;

      if (value === null) {
        return null;
      } else if (creditCardService.validateExpiryFormat(value)) {
        return null;
      } else {
        return { expiryFormat: true };
      }
    };
  }

  static expiryDate(creditCardService: CreditCardService, reference?: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string | null = control.value;

      if (value === null || creditCardService.validateExpiryFormat(value) === false) {
        return null;
      } else if (creditCardService.validateExpiryDate(value, reference)) {
        return null;
      } else {
        return { cardExpired: true };
      }
    };
  }

  static cvc(control: AbstractControl): ValidationErrors | null {
    const value: string | null = control.value;
    if (value === null) {
      return null;
    } else if (value.replace(/ /g, '').match(/^ *[0-9]{3,4} *$/)) {
      return null;
    } else {
      return { cvc: true };
    }
  }
}
